import fonts from './fonts';
import responsive from './responsive';
import spacing from './spacing';
// import spacing from './spacing';

export const mainColor = '#303030';
export const secondaryColor = '#0C00B0';
export const tertiaryColor = '#8F8F8F';

export const newsBorderColor = '#DBDBDB'

export const enum directions {
    top = 1,
    bottom = 1 << 1,
    left = 1 << 2,
    right = 1 << 3,
    all = 1 | 1 << 1 | 1 << 2 | 1 << 3,
    sides = 1 << 2 | 1 << 3
};

// const prefixed = (prefix: string, value: number, multi: number = 1, dir: directions = directions.sides) => ({
//     [prefix ? `${prefix}Left` : 'left']:
//         (dir & directions.left) === directions.left && value * multi || undefined,
//     [prefix ? `${prefix}Right` : 'right']:
//         (dir & directions.right) === directions.right && value * multi || undefined,
//     [prefix ? `${prefix}Bottom` : 'bottom']:
//         (dir & directions.bottom) === directions.bottom && value * multi || undefined,
//     [prefix ? `${prefix}Top` : 'top']:
//         (dir & directions.top) === directions.top && value * multi || undefined
// });

export const bodyFontSize = {
    'Mobile': 16,
    'Tablet': 16,
    'Laptop': 16,
    'Desktop': 16,
}

export const regExp = /\$([^\$]*)\$/gi;

export default {
    'Body': {
        ...fonts.normal,
        color: mainColor,
        [responsive.Mobile]: {
            fontSize: bodyFontSize.Mobile,
        },
        [responsive.Tablet]: {
            fontSize: bodyFontSize.Tablet,
        },
        [responsive.Laptop]: {
            fontSize: bodyFontSize.Laptop,
        },
        [responsive.Desktop]: {
            fontSize: bodyFontSize.Desktop,
        },
    },
    'BoldText': {
        ...fonts.bold,
    },
    'MediumText': {
        ...fonts.medium,
    },
    'RegulerText': {
        ...fonts.normal,
    },
    'MediumItalicText': {
        ...fonts.mediumItalic,
    },
    'Light': {
        ...fonts.light,
    },
    'MainTitle': {
        ...fonts.medium,
        lineHeight: '1',
        marginBottom: 3,
        color: secondaryColor,
        [responsive.Mobile]: {
            fontSize: `${30 / bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            fontSize: `${43 / bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            fontSize: `${43 / bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            fontSize: `${43 / bodyFontSize.Desktop}rem`,
        },
    },
    'MainTitleNews': {
        ...fonts.medium,
        lineHeight: '1',
        marginBottom: 3,
        color: secondaryColor,
        [responsive.Mobile]: {
            fontSize: `${28 / bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            fontSize: `${42 / bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            fontSize: `${42 / bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            fontSize: `${42 / bodyFontSize.Desktop}rem`,
        },
    },
    'NewsMainTitle': {
        ...fonts.normal,
        lineHeight: '1',
        marginBottom: 3,
        color: secondaryColor,
        [responsive.Mobile]: {
            fontSize: `${26 / bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            fontSize: `${38 / bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            fontSize: `${38 / bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            fontSize: `${38 / bodyFontSize.Desktop}rem`,
        },
    },
    'SubTitle': {
        ...fonts.light,
        lineHeight: 1,
        marginBottom: 3,
        color: secondaryColor,
        [responsive.Mobile]: {
            fontSize: `${30 / bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            fontSize: `${44 / bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            fontSize: `${44 / bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            fontSize: `${44 / bodyFontSize.Desktop}rem`,
        },
    },
    'SubTitleNews': {
        ...fonts.light,
        lineHeight: 1,
        marginBottom: 3,
        color: secondaryColor,
        [responsive.Mobile]: {
            fontSize: `${28 / bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            fontSize: `${42 / bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            fontSize: `${42 / bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            fontSize: `${42 / bodyFontSize.Desktop}rem`,
        },
    },
    'BlueTitle': {
        ...fonts.normal,
        color: secondaryColor,
    },
    'Quote': {
        ...fonts.mediumItalic,
        [responsive.Mobile]: {
            paddingLeft: spacing.Gutter.Mobile,
            fontSize: `${25 / bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            paddingLeft: spacing.Gutter.Tablet,
            fontSize: `${38 / bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            paddingLeft: spacing.Gutter.Laptop,
            fontSize: `${38 / bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            paddingLeft: spacing.Gutter.Desktop,
            fontSize: `${38 / bodyFontSize.Desktop}rem`,
        },
    },
    'QuoteNews': {
        ...fonts.mediumItalic,
        [responsive.Mobile]: {
            paddingLeft: spacing.Gutter.Mobile,
            fontSize: `${23 / bodyFontSize.Mobile}rem`,
        },
        [responsive.Tablet]: {
            paddingLeft: spacing.Gutter.Tablet,
            fontSize: `${36 / bodyFontSize.Tablet}rem`,
        },
        [responsive.Laptop]: {
            paddingLeft: spacing.Gutter.Laptop,
            fontSize: `${36 / bodyFontSize.Laptop}rem`,
        },
        [responsive.Desktop]: {
            paddingLeft: spacing.Gutter.Desktop,
            fontSize: `${36 / bodyFontSize.Desktop}rem`,
        },
    },
    'ObjectFitCover': {
        fontFamily: '"object-fit: cover;"'
    },
    'ObjectFitContain': {
        fontFamily: '"object-fit: contain;"'
    }
    // 'PaddingGutter': (multi: number = 1, dir: directions = directions.sides) => ({
    //     [responsive.Mobile]: prefixed('padding', spacing.Gutter.Mobile, multi, dir),
    //     [responsive.Tablet]: prefixed('padding', spacing.Gutter.Tablet, multi, dir),
    //     [responsive.Laptop]: prefixed('padding', spacing.Gutter.Laptop, multi, dir),
    //     [responsive.Desktop]: prefixed('padding', spacing.Gutter.Desktop, multi, dir),

    // }),
    // 'MarginGutter': (multi: number = 1, dir: directions = directions.sides) => ({
    //     [responsive.Mobile]: prefixed('margin', spacing.Gutter.Mobile, multi, dir),
    //     [responsive.Tablet]: prefixed('margin', spacing.Gutter.Tablet, multi, dir),
    //     [responsive.Laptop]: prefixed('margin', spacing.Gutter.Laptop, multi, dir),
    //     [responsive.Desktop]: prefixed('margin', spacing.Gutter.Desktop, multi, dir)
    // }),
    // 'PostionGutter': (multi: number = 1, dir: directions = directions.sides) => ({
    //     [responsive.Mobile]: prefixed('', spacing.Gutter.Mobile, multi, dir),
    //     [responsive.Tablet]: prefixed('', spacing.Gutter.Tablet, multi, dir),
    //     [responsive.Laptop]: prefixed('', spacing.Gutter.Laptop, multi, dir),
    //     [responsive.Desktop]: prefixed('', spacing.Gutter.Desktop, multi, dir)
    // })
};


// WEBPACK FOOTER //
// ./src/constants/stylesheet.ts